export default [
  {
    id: 'Gg-OPQiGtXo',
    title: 'VideoPopup.snotrGuide',
    breakpoints: [
      { time: '00:13', title: 'VideoPopup.settings' },
      { time: '02:34', title: 'VideoPopup.products' },
      { time: '04:19', title: 'VideoPopup.customers' },
      { time: '06:25', title: 'VideoPopup.ordersAndInvoices' },
    ],
  },
];
